import React from "react";
import Carousel from "react-multi-carousel";
import { useNavigate } from "react-router-dom";

import item1 from "../../assets/images/coffee.png";

const HotSellingArrows = ({ previous, next }) => (
  <>
    <button className="custom-arrow left" onClick={previous} type="button" aria-label="Previous">
      <i className="ri-arrow-left-line"></i>
    </button>
    <button className="custom-arrow right" onClick={next} type="button" aria-label="Next">
      <i className="ri-arrow-right-line"></i>
    </button>
  </>
);

const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1050 }, items: 4 },
  tablet: { breakpoint: { max: 1050, min: 780 }, items: 3 },
  mobile: { breakpoint: { max: 780, min: 460 }, items: 2 },
  mobileMin: { breakpoint: { max: 460, min: 0 }, items: 1 },
};

const HotSelling = ({ categories = [], loading }) => {
  const navigate = useNavigate();

  return (
    <section id="hot-selling">
      <div className="wrapper">
        <div className="hot-selling-header">
          <h2>HOT SELLING ITEMS</h2>

          <button
            className="visit-store-btn"
            onClick={() => navigate("/store")}
          >
            VISIT STORE
          </button>
        </div>

        {!loading && categories.length === 0 ? (
          <p className="section-empty-message">No hot selling items available right now.</p>
        ) : (
          <div className="hot-selling-carousel-wrap">
            <Carousel
              responsive={responsive}
              arrows={false}
              infinite
              renderButtonGroupOutside
              customButtonGroup={<HotSellingArrows />}
            >
              {categories.map((item) => (
                <div
                  className="hot-selling-card"
                  key={item.CategoryId}
                  // onClick={() =>
                  //   navigate(`/store?categoryId=${item.CategoryId}`)
                  // }
                >
                  <img
                    src={item.CategoryPicture?.Url || item1}
                    alt={item.CategoryName}
                  />

                  <h4>{item.CategoryName}</h4>

                  <p>{item.CategoryDescription}</p>
                </div>
              ))}
            </Carousel>
          </div>
        )}
      </div>
    </section>
  );
};

export default HotSelling;